
import { REQUIRED_DIAGNOSTIC_IDS, TIER_A_IDS, TIER_D_IDS } from "./auditContract";

export interface RepairItem {
    id: string;
    priority: "P0" | "P1" | "P2";
    area: string;
    symptom: string;
    likely_root_cause: string;
    evidence: string[];
    owner_hint: string;
    fix_hint: string;
}

/**
 * GSC REPAIR MAP BUILDER v1.0
 * Traduit les échecs de test en actions de maintenance.
 */
export function buildRepairMap(report: any): RepairItem[] {
    const map: RepairItem[] = [];
    const fails = [
        ...(report.diagnostics || []).filter((d: any) => !d.passed).map((d: any) => d.id),
        ...(report.stress || []).filter((s: any) => !s.passed).map((s: any) => s.id)
    ];

    if (fails.includes("CORE_PARITY")) {
        map.push({
            id: "REP_DSP_01",
            priority: "P0",
            area: "DSP_INTEGRITY",
            symptom: "Divergence de calcul entre thread UI et Worker.",
            likely_root_cause: "Logique mathématique non synchronisée dans dspMath.ts vs workerScript.ts",
            evidence: ["CORE_PARITY"],
            owner_hint: "DSP Engineer / Architect",
            fix_hint: "S'assurer que les fonctions de dspMath.ts sont importées/utilisées à l'identique dans le worker."
        });
    }

    if (fails.includes("DATA_CONTRACT")) {
        map.push({
            id: "REP_UI_01",
            priority: "P0",
            area: "UI_CONTRACT",
            symptom: "Le visualiseur Radar ou Rhythm reçoit des champs undefined.",
            likely_root_cause: "Analyse partielle retournant des métriques manquantes.",
            evidence: ["DATA_CONTRACT"],
            owner_hint: "Frontend Lead",
            fix_hint: "Vérifier dspAdapter.ts et uiDataPolicy.ts."
        });
    }

    if (fails.includes("PERF_0") || fails.includes("PERF_1")) {
        map.push({
            id: "REP_PERF_01",
            priority: "P1",
            area: "RUNTIME_PERF",
            symptom: "Latence excessive détectée sur le pipeline p95.",
            likely_root_cause: "Garbage collection intensif ou thread blocking.",
            evidence: fails.filter(f => f.startsWith("PERF")),
            owner_hint: "Performance Engineer",
            fix_hint: "Profiler le worker et réduire les allocations d'objets dans les boucles STFT."
        });
    }

    if (fails.includes("SOAK_0") || fails.includes("MEMORY_7")) {
        map.push({
            id: "REP_MEM_01",
            priority: "P0",
            area: "MEMORY_MANAGEMENT",
            symptom: "Fuite heuristique de ressources (ObjectURL / AudioBuffer).",
            likely_root_cause: "URL.createObjectURL appelé sans URL.revokeObjectURL correspondant.",
            evidence: ["SOAK_0", "MEMORY_7"],
            owner_hint: "Core Dev",
            fix_hint: "Vérifier le cycle de vie dans cleanupAllMemory et memoryService.ts."
        });
    }

    return map.sort((a, b) => a.priority.localeCompare(b.priority));
}
